import { render, staticRenderFns } from "./GenericCUArtistCard.vue?vue&type=template&id=89d0fdae&scoped=true"
import script from "./GenericCUArtistCard.vue?vue&type=script&lang=js"
export * from "./GenericCUArtistCard.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/CU_artist.css?vue&type=style&index=0&id=89d0fdae&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d0fdae",
  null
  
)

export default component.exports